import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  Button,
  useMediaQuery,
  IconButton,
  ListItemButton,
  List,
  ListItemText,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import joinBGRight from "../images/join-bg-right.jpg";
import targetImage from "../images/home_bg.jpg";
import caseStudiesBg from "../images/case_studies_bg.jpg";
import { Assignment } from "@mui/icons-material";
import jeremiahHome2 from "../images/jeremiahHome2.jpg";
import meet1 from "../images/meet-jeremiah-1.jpg";
import meet2 from "../images/meet-jeremiah-2.jpg";
import meet3 from "../images/meet-jeremiah-3.jpg";
import EmailSignupModal from "./EmailSignupModal";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import logo512 from "../images/jeremiahLogo.png";
import XIcon from "@mui/icons-material/X";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  testimonialSection: {
    padding: theme.spacing(8, 0),
    textAlign: "center",
  },
  testimonial: {
    padding: theme.spacing(2),
    position: "relative",
    "&:before": {
      content: '"\\201c"',
      fontFamily: '"Times New Roman", Times, serif',
      display: "block",
      fontSize: "72px",
      lineHeight: "50px",
      fontWeight: 700,
      textAlign: "left",
      position: "static",
      color: "#FFFFFF",
    },
  },
  servicesSection: {
    textAlign: "center",
  },
  caseStudiesSection: {
    backgroundImage: `url(${caseStudiesBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    padding: theme.spacing(8, 2),
    textAlign: "left",
  },
}));

const Home = () => {
  const [showDonate, setShowDonate] = useState(false);
  const location = useLocation();
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isPrioritiesPage = location.pathname === "/priorities";
  const [emailOpen, setEmailOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const posterUrl = process.env.PUBLIC_URL + "/jeremiah_poster.jpg";
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    if (location.hash === "#meet-jeremiah") {
      // delay a tick so DOM is ready
      setTimeout(() => {
        const el = document.getElementById("meet-jeremiah");
        if (el) {
          const appBar =
            document.querySelector(".MuiAppBar-root") ||
            document.querySelector("header");
          const offset =
            appBar && appBar.offsetHeight ? appBar.offsetHeight : 120;
          const y =
            el.getBoundingClientRect().top + window.pageYOffset - offset - 16; // extra padding
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 50);
    }
  }, [location.hash]);

  // useEffect(() => {
  //   if (isHomePage) {
  //     const hasSeenPopup = localStorage.getItem("emailPopupSeen");

  //     if (!hasSeenPopup) {
  //       setTimeout(() => {
  //         setEmailOpen(true);
  //         localStorage.setItem("emailPopupSeen", "true");
  //       }, 2500); // load delay
  //     }
  //   }
  // }, [isHomePage]);

  // useEffect(() => {
  //   if (isMobile) {
  //     setShowDonate(true);
  //   } else {
  //     const handleScroll = () => {
  //       setShowDonate(window.scrollY > 100);
  //     };
  //     window.addEventListener("scroll", handleScroll);
  //     return () => window.removeEventListener("scroll", handleScroll);
  //   }
  // }, [isMobile]);

  return (
    <Box>
      <Box
        className={classes.header}
        sx={{
          backgroundImage: isPrioritiesPage
            ? "none"
            : `radial-gradient(circle at 78% 98%, rgba(29,40,69,0.1) 14%, rgb(29 40 69) 86%), url(${targetImage})`,
          backgroundColor: isPrioritiesPage ? "#0073e6" : "transparent",
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
          height: isPrioritiesPage ? "200px" : isMobile ? "auto" : "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: isPrioritiesPage ? "2rem" : "8rem",
          textAlign: "center",
        }}
      >
        {isMobile && (
          <Box
            sx={{
              justifyContent: "center",
              alignItems: "center",
              width: "100px",
              position: "relative",
              top: "4rem",
              left: "1rem",
              padding: "8px",
              background: "transparent",
            }}
          >
            <img
              src={logo512}
              alt="Jeremiah Pope Logo"
              style={{
                borderRadius: ".5rem",
                background: "white",
                padding: ".25rem",
                boxShadow:
                  "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
                maxWidth: "200px",
              }}
            />
          </Box>
        )}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{
            position: "absolute",
            right: 0,
            bottom: "3rem",
            width: "68vw",
            zIndex: 10,
            textAlign: "center",
            color: "white",
            display: isMobile ? "none" : "auto",
            px: 2,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "#00853e",
              fontSize: "5rem!important",
              fontWeight: "bold!important",
              background: "#1d2845d1",
              borderRadius: "8px",
              padding: "8px 16px",
              pointerEvents: "auto",
            }}
          >
            Lifting Every Voice
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100vh",
            width: "38vw",
            zIndex: 10,
            textAlign: "center",
            color: "white",
            display: isMobile ? "none" : "auto",
            px: 2,
          }}
        >
          {/* Top Tagline */}
          <Typography
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              fontSize: { xs: "2rem", sm: "2.5rem" },
            }}
          >
            Support Jeremiah Pope
          </Typography>

          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1.25rem", sm: "1.25rem" },
              lineHeight: 1.1,
              maxWidth: "90vw",
              my: 1,
            }}
          >
            Democratic Primary: <br></br>
            <Typography
              sx={{
                color: "#00853e",
                fontWeight: 700,
                fontSize: { xs: "1.25rem", sm: "1.25rem" },
              }}
            >
              June 23, 2026
            </Typography>
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1.25rem", sm: "1.25rem" },
              lineHeight: 1.1,
              maxWidth: "90vw",
              mb: 2,
            }}
          >
            Early Voting: <br></br>
            <Typography
              sx={{
                color: "#00853e",
                fontWeight: 700,
                fontSize: { xs: "1.25rem", sm: "1.25rem" },
              }}
            >
              June 11-18
            </Typography>
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1.25rem", sm: "1.25rem" },
              lineHeight: 1.1,
              maxWidth: "90vw",
              mb: 2,
            }}
          >
            To Vote by Mail, apply for your mail ballot{" "}
            <a
              href="https://voterservices.elections.maryland.gov/OnlineMailinRequest/InstructionsStep1"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#00853e", textDecoration: "underline" }}
            >
              here
            </a>
            .
          </Typography>

          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            style={{ width: "100%" }}
          >
            <input
              type="hidden"
              name="access_key"
              value="cbee500a-aca1-424f-b45b-51aa780c842e"
            />
            <Grid container spacing={1} justifyContent="center" mb={1}>
              <Grid item>
                <TextField
                  variant="filled"
                  placeholder="Email Address"
                  name="email"
                  type="email"
                  required
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 300,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  variant="filled"
                  placeholder="Zip"
                  name="zip"
                  required
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 200,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} justifyContent="center">
              <Grid item>
                <TextField
                  variant="filled"
                  placeholder="Phone Number"
                  name="phone"
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 300,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />
              </Grid>
              <Grid item>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    height: 56,
                    backgroundColor: "#00853e",
                    borderRadius: 0,
                    width: 200,
                    px: 4,
                    fontWeight: "bold",
                    fontSize: "1rem",
                    "&:hover": { backgroundColor: "#cc8500" },
                  }}
                >
                  JOIN
                </Button>
              </Grid>
            </Grid>
          </form>
          {/* Disclaimer */}
          <Typography
            variant="caption"
            sx={{ maxWidth: 500, opacity: 0.7, mt: 2, fontSize: "0.75rem" }}
          >
            By providing your cell phone number you consent to receive recurring
            donation & campaign updates.
          </Typography>
        </Grid>

        <Grid container justifyContent="center">
          <Typography
            variant="h2"
            sx={{
              color: "#FFFFFF",
              fontSize: isPrioritiesPage ? "2.5rem" : "4rem",
              fontWeight: 700,
            }}
          >
            {isPrioritiesPage ? "Priorities" : ""}
          </Typography>
        </Grid>
      </Box>

      {/* MEET JEREMIAH Section */}
      <Grid
        container
        display="flex"
        justifyContent="center"
        px={6}
        py={12}
        flexDirection="column"
        sx={{
          background: `#1d2845!important`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: isMobile ? "2rem 0" : "6rem 3rem",
          color: "#fff",
        }}
        alignItems="center"
      >
        {/* {showDonate && (
          <Grid className="donate-top">
            <List>
              <ListItemButton
                component="a"
                href="/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemText primary="DONATE" />
              </ListItemButton>
            </List>
          </Grid>
        )} */}

        {/* Jeremiah Description */}
        <Grid
          container
          display="flex"
          flexDirection="row"
          justifyContent="center"
        >
          <Grid
            item
            display="flex"
            flexDirection="column"
            xs={12}
            md={6}
            mt={isMobile ? 2 : 4}
            mb={isMobile ? 2 : 0}
            sx={{ borderRadius: ".5rem" }}
          >
            <div
              style={{
                padding: isMobile ? "1rem" : "0",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  borderRadius: "16px",
                  overflow: "hidden",
                  aspectRatio: "16/9",
                  backgroundColor: "#000",
                }}
              >
                {!showVideo ? (
                  <>
                    <img
                      src={posterUrl}
                      alt="Jeremiah video poster"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = jeremiahHome2;
                      }}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />

                    <div
                      onClick={() => setShowVideo(true)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={() => setShowVideo(true)}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      aria-label="Play video"
                    >
                      <div
                        style={{
                          width: 90,
                          height: 90,
                          borderRadius: "50%",
                          background: "rgba(0,0,0,0.6)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </>
                ) : (
                  <iframe
                    title="Jeremiah Pope Video"
                    src="https://www.youtube.com/embed/TgmCTiwc8RE?autoplay=1"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: 0,
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                )}
              </div>
            </div>
          </Grid>
          <Grid container md={6} justifyContent="center">
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="center"
              lg={8}
              sx={{
                fontStyle: "normal",
                fontWeight: "500",
                maxWidth: !isMobile ? "50vw" : "auto",
                fontSize: "1.25rem",
                lineHeight: "1.6875",
                fontFamily: "'Open Sans', sans-serif",
                letterSpacing: "0em",
                textAlign: "left",
                color: "#FFFFFF",
                mb: 2,
              }}
            >
              <Typography variant="h5" sx={{  color:"#00853e!important" }}>
                <span
                  style={{
                    fontSize: "3rem",
                    marginRight: "4px",
                    lineHeight: "0",
                    color: "white"
                  }}
                >
                  "
                </span>
                Montgomery County deserves someone that will value all our
                diverse voices, be responsive to our needs, and positively
                impact our quality of life.
                <span
                  style={{
                    fontSize: "3rem",
                    marginLeft: "4px",
                    lineHeight: "0",
                    color: "white"
                  }}
                >
                  "
                </span>
                <br></br>
                <br></br>Jeremiah Pope
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        id="meet-jeremiah"
        container
        justifyContent="center"
        px={6}
        py={6}
        sx={{ width: "100%", background: `#1d2845!important` }}
      >
        <Grid
          container
          xs={12}
          sx={{
            color: "#FFFFFF",
            textAlign: "left",
            fontSize: "1rem",
            lineHeight: 1.75,
            mb: 2,
          }}
        >
          <Grid item xs={6} p={2}>
            <Typography
              variant="h3"
              sx={{
                mb: 4,
                textAlign: "left",
              }}
            >
              Meet Jeremiah
            </Typography>
            <Typography variant="body1" paragraph>
              Jeremiah Pope has been a resident of Montgomery County, Maryland
              for nearly twenty years, moving here to work for Tom Perez for
              Maryland Attorney General.
            </Typography>

            <Typography variant="body1" paragraph>
              In 2006, Jeremiah started a small business, J Pope Consulting, a
              professional fundraising and consulting company. He saw the
              absence of Blacks in the political space, and he wanted to change
              the deficiency of diversity in the industry. Through
              determination, hard work, and drive to affect change in his
              community, he persevered to grow his small minority-owned business
              into a premier fundraising business in the D.C. Metro Area.
              Eighteen years later, J Pope Consulting has been an integral part
              in diversifying the industry and winning Democratic races up and
              down the ballot.
            </Typography>
            <Typography variant="body1" paragraph>
              Jeremiah was a pivotal part of the election of Donna F. Edwards,
              the first African American woman to Congress from the State of
              Maryland. Jeremiah also had leading roles in the elections of many
              other notable Congressional Black Caucus Members.
            </Typography>
          </Grid>
          <Grid item xs={6} mt={3} p={2}>
            <Box display="flex" justifyContent="center" my={3}>
              <Box
                component="img"
                src={meet1}
                alt="meet-jeremiah-1"
                sx={{ width: "100%", maxWidth: 720, borderRadius: 2 }}
              />
            </Box>
          </Grid>
          <Grid item xs={6} mt={6} p={2}>
            <Box display="flex" justifyContent="center" my={3}>
              <Box
                component="img"
                src={meet2}
                alt="meet-jeremiah-2"
                sx={{ width: "100%", maxWidth: 720, borderRadius: 2 }}
              />
            </Box>
          </Grid>

          <Grid item xs={6} mt={10} p={2}>
            <Typography variant="body1" paragraph>
              In 2019, Jeremiah accepted a public servant position as the Chief
              of Staff in the office of Maryland’s Deputy Majority Whip,
              Delegate Charlotte Crutchfield. He has worked with advocates,
              stakeholders, and members of the Maryland General Assembly to
              draft, pass, and implement legislation that breaks down systemic
              barriers, protects women and children, fights against hate crimes,
              and improves access to services for all Marylanders.
            </Typography>
            <Typography variant="body1" paragraph>
              Since moving to Montgomery County, Jeremiah has actively worked to
              maintain and improve our community. He had the honor of serving as
              the president of the Hillandale Citizens Association, the only
              other Black president since 1998. In addition, he served on the
              boards of the East County Citizens Advisory Board, Friends of
              White Oak, the Community Services Agency of the Metropolitan
              Washington Council AFL-CIO, the Association of Black Democrats of
              Montgomery County, Iota Upsilon Lambda Chapter of Alpha Phi Alpha
              Fraternity, Inc., the National Pan-Hellenic Council of Montgomery
              County, the NAACP Parents’ Council, and Chair of the Maryland
              Democratic Party African American Diversity Leadership Council.
            </Typography>
          </Grid>
          <Grid item xs={6} mt={10} p={2}>
            <Typography variant="body1" paragraph>
              Jeremiah was born in Nashville, Tennessee, and grew up in Aiken,
              South Carolina. He was raised by his grandmother, a nurse, and his
              grandfather, a railroad worker. His grandparents instilled in him
              the value of education, faith, honesty, hard work, and civic duty.
              As a child, Jeremiah participated in the local NAACP meetings with
              his grandmother because she wanted to ensure that he understood
              what it means to advocate for one’s community.
            </Typography>
            <Typography variant="body1" paragraph>
              After graduating from a public high school, Jeremiah was accepted
              to the College of Charleston in Charleston, South Carolina. While
              in college, Jeremiah was a recipient of a work study grant. He
              worked at the college library and met his future wife, Angie, who
              also worked at the library. Jeremiah became a member of Alpha Phi
              Alpha Fraternity, Inc. and worked at Wings for Kids, a program
              that served marginalized youth. His wife Angie is a member of Zeta
              Phi Beta Sorority, Inc.
            </Typography>
            <Typography variant="body1" paragraph>
              In 2003, Jeremiah graduated from the College of Charleston with a
              Bachelor of Arts in Political Science. He then headed to
              Washington, D.C. to participate in a prestigious internship with
              United States Senator Ernest "Fritz" Hollings as well as with the
              EMILY’s List Campaign Corps program.
            </Typography>
            <Typography variant="body1" paragraph>
              After his internships, Jeremiah began his professional career
              working around the country campaigning for Democrats to local,
              state, and federal offices. During this time, Jeremiah earned a
              Master of Arts in Public Policy degree from New England College.
            </Typography>
            <Typography variant="body1" paragraph>
              Jeremiah and his wife attend Kingdom Fellowship AME Church in
              Calverton, Maryland with their son who is an elementary student in
              Montgomery County Public Schools. They are proud active members of
              their son’s elementary school’s Parent Teacher Association (PTA)
              of which Angie served as President. Jeremiah and his family live
              in the Silver Spring area of Montgomery County, Maryland.
            </Typography>
          </Grid>
          <Grid item xs={6} mt={6} p={2}>
            <Box display="flex" justifyContent="center" my={3}>
              <Box
                component="img"
                src={meet3}
                alt="meet-jeremiah-3"
                sx={{ width: "100%", maxWidth: 720, borderRadius: 2 }}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {/* Volunteer Section */}
      <Grid
        container
        flexDirection="row"
        sx={{ background: "#FFFDF7!important" }}
      >
        <Grid
          id="learn-more-deb"
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{ minHeight: "300px" }}
          md={12}
        >
          <Grid item sx={volunteerHeaderStyle(isMobile)}>
            <Typography variant="h3">Join Jeremiah's Team</Typography>
          </Grid>

          <Grid item sx={volunteerButtonStyle(isMobile)}>
            <Button
              startIcon={
                <Assignment
                  sx={{ fontSize: "5rem!important", color: "white" }}
                />
              }
              sx={{
                padding: "1rem 2rem",
                color: "white!important",
                background: "#00853e!important",
                border: "1px solid white",
                boxShadow:
                  "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
              }}
              href=""
              target="_blank"
            >
              <Typography variant="h3" sx={{ color: "white!important" }}>
                Volunteer Today!
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          pb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setEmailOpen(true)}
              sx={{
                textTransform: "none",
                background: "#FFFDF7!important",
                color: "#1d2845!important",
              }}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/JeremiahPope320/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/votejeremiah2026"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/VoteJeremiahDistrict7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By Authority: Pope For Council, Angie Logan-Pope, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};

const volunteerHeaderStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  fontSize: "16px",
  lineHeight: "1.6875",
  fontFamily: "'Open Sans', sans-serif",
  textAlign: "center",
  color: "#00853e!important",
  mt: 2,
  mb: 4,
  px: 2,
});

const volunteerButtonStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  mt: 2,
  mb: 2,
  px: 2,
});

const volunteerFooterStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  mt: 2,
  mb: 2,
  px: 2,
  fontSize: "8px",
  lineHeight: "1.6875",
  textAlign: "center",
  border: "1px solid #00853e!important",
  borderRadius: ".25rem",
  color: "#00853e!important",
});

export default Home;
